<template>
  <div class="min-h-screen bg-white flex flex-col items-center overflow-hidden">
    <div class="w-full">
      <!-- 顶部导航 -->
      <header
        class="flex items-center justify-between h-[72px] w-full max-w-[1600px] mx-auto px-140"
      >
        <div class="flex items-center space-x-2">
          <img src="../assets/home_logo.png" alt="logo" style="width: 180px;height: 30px;" />
        </div>
        <nav class="flex items-center space-x-8">
          <el-dropdown class="text-white mr-50" @command="handleCommand">
            <span class="flex items-center cursor-pointer hover:text-orange-500 transition">
              <span
                class="mr-30 pt-3"
                style="font-size: 14px;"
              >{{ $i18n.locale === 'zh' ? '中文' : 'English' }}</span>
              <i class="el-icon-arrow-down" style="color: #FF7800;font-size: 14px;"></i>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="zh" style="font-size: 14px;">中文</el-dropdown-item>
                <el-dropdown-item command="en" style="font-size: 14px;">English</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <button
            class="text-white px-6 py-1.5 rounded hover:bg-orange-600 transition"
            style="font-size: 14px;margin-right: 50px;cursor: pointer;"
            @click="goLogin"
          >登录</button>

          <el-button
            class="min-w-64 h-35 text-center"
            type="primary"
            style="font-size: 14px;background: #FF7800;border-radius: 5px 5px 5px 5px;border: 1px solid #FF7800;padding: 10px;box-sizing: border-box; line-height: 12px;"
            @click="goRegister"
          >一键注册</el-button>
        </nav>
      </header>

      <section
        class="relative w-full h-[700px] bg-black overflow-hidden mb-16 px-104 pt-120"
      >
        <div class="max-w-[1600px] w-full mx-auto flex">
          <img src="../assets/leopard.gif" alt class="w-1/2 h-437 mr-50 object-scale-down" />
          <div class="flex flex-col justify-center text-left w-1/2">
            <div class="text-white text-1xl mb-10">{{$t('lang.banner1')}}</div>
            <div class="text-white font-bold mb-5" style="font-size: 45px;">{{$t('lang.banner2')}}</div>
            <div class="text-white mb-50" style="font-size: 22px;">{{$t('lang.banner3')}}</div>
            <div class="text-white text-sm mb-20 w-500">{{$t('lang.banner4')}}</div>
            <div class="flex items-center space-x-4 mb-10">
              <el-input v-model="email" :placeholder="$t('lang.banner5')" style="width: 320px" />
              <el-button
                type="primary"
                style="background: #FF7800;border-radius: 5px 5px 5px 5px;border: 1px solid #FF7800;"
                @click="goRegister"
              >{{$t('lang.banner6')}}</el-button>
            </div>
            <!-- <div>
              <el-checkbox v-model="isAgree">
                我同意
                <span class="underline cursor-pointer">《隐私政策》</span>及相关条款。
              </el-checkbox>
            </div>-->
          </div>
        </div>
      </section>

      <!-- 支付场景覆盖 -->
      <sectionPay />
      <!-- 智能费用管控 -->
      <sectionCost />
      <!-- 安全合规与双保险 -->
      <sectionSecure />
      <!-- 支付速度 -->
      <sectionSpeed />
      <!-- 常见问题 -->
      <qa />
      <!-- 选择我们 -->
      <chooseUs />

      <!-- 页脚 -->
      <div class="bg-[#f7f7f7]">
        <Footer />
      </div>


      <!-- 右侧固定浮窗，显示客服二维码,上下结构，上面标题客服微信，下面图片  -->
      <div class="fixed bottom-60 right-20 z-50 flex flex-col items-center bg-white rounded-lg p-10">
        <div class="text-black text-sm mb-10">{{$t('lang.contact1')}}</div>
        <img src="../assets/qrCode.jpg" alt="销售微信" class="w-100 h-100" />
      </div>
    </div>
  </div>
</template>

<script>
import sectionPay from "./sectionPay.vue";
import sectionCost from "./sectionCost.vue";
import sectionSecure from "./sectionSecure.vue";
import sectionSpeed from "./sectionSpeed.vue";
import qa from "./qa.vue";
import chooseUs from "./chooseUs.vue";
import Footer from "./Footer.vue";
// 无需 JS 逻辑
export default {
  name: "Home",
  components: {
    sectionPay,
    sectionCost,
    sectionSecure,
    sectionSpeed,
    qa,
    chooseUs,
    Footer
  },
  data() {
    return {
      email: ""
    };
  },
  mounted() {
    // this.$i18n.locale = 'zh';
    // 获取当前屏幕的宽度
    const screenWidth = window.innerWidth;
    console.log(screenWidth);
    // if (screenWidth < 1600) {
    //   this.$router.push('/mobile');
    // }
    const lang = localStorage.getItem("lang");
    if (lang) {
      this.$i18n.locale = lang;
    }
  },
  methods: {
    handleCommand(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("lang", lang);
      // setCookie('lang', lang);
    },
    goLogin() {
      window.open("https://vccmmr.geo.sh.cn/#/login");
    },
    goRegister() {
      window.open("https://vccmmr.geo.sh.cn/#/register?email=" + this.email);
    }
  }
};
</script>



<style lang="less">
// 设置根字体大小，动态 rem 保证适配如何做

.el-input__inner {
  background-color: transparent !important;
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #7c7c7c;
}
.el-checkbox__inner {
  background-color: transparent !important;
  border: 1px solid #7c7c7c;
}
</style>